module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-9.e9915a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-9.jpg
// module id = c9pY
// module chunks = 1